<template lang="html">
  <div class='popup' id="privacy">
    <p class='popup-title'>
      Согласие на обработку персональных данных.
    </p>
    <p>
      Настоящим в соответствии с Федеральным законом № 152-ФЗ «О персональных данных» от 27.07.2006 года свободно, своей волей и в своем интересе выражаю свое безусловное согласие на обработку моих персональных данных , зарегистрированным в соответствии с законодательством РФ по адресу: (далее по тексту - Оператор). Персональные данные - любая информация, относящаяся к определенному или определяемому на основании такой информации физическому лицу. Настоящее Согласие выдано мною на обработку следующих персональных данных: - Ваше имя; - Ваш mail; - Номер телефона; Согласие дано Оператору для совершения следующих действий с моими персональными данными с использованием средств автоматизации и/или без использования таких средств: сбор, систематизация, накопление, хранение, уточнение (обновление, изменение), использование, обезличивание, а также осуществление любых иных действий, предусмотренных действующим законодательством РФ как неавтоматизированными, так и автоматизированными способами. Данное согласие дается Оператору для обработки моих персональных данных в следующих целях: - предоставление мне услуг/работ; - направление в мой адрес уведомлений, касающихся предоставляемых услуг/работ; - подготовка и направление ответов на мои запросы; - направление в мой адрес информации, в том числе рекламной, о мероприятиях/товарах/услугах/работах Оператора. Настоящее согласие действует до момента его отзыва путем направления соответствующего уведомления на электронный адрес man@vcis.pro. В случае отзыва мною согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без моего согласия при наличии оснований, указанных в пунктах 2 – 11 части 1 статьи 6, части 2 статьи 10 и части 2 статьи 11 Федерального закона №152-ФЗ «О персональных данных» от 27.06.2006 г.
    </p>
  </div>
</template>

<script>
export default {
  name: "PrivacyPopup"
}
</script>

<style lang="scss" scoped>
  .popup{
    background: #fff;
    padding: 30px 37px 30px;
    z-index: 601;
    margin-top: 30px;
    border-radius: 6px;
    line-height: 23px;
    width: 900px;
    height: fit-content;
    font-family: 'SegoeUIRegular', Arial, 'PT Sans Caption' !important;

    .popup-title{
      margin-bottom: 25px;
    }

    p{
      font-size: 15.5px;
      line-height: 23px;
    }
  }

  @media screen and (max-width: 1000px){
    .popup{
      width: 650px !important;
    }
  }

  @media screen and (max-width: 767px){
    .popup{
      width: calc(100% - 30px) !important;
    }
  }
</style>
